import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests.js';
import { LanguageOptions } from '../../entities/LanguageOptions/index.js';
import { Availability } from '../../entities/Availability/index.js';
import { toast } from 'react-toastify';
import { CreateContent } from '../../features/CreateContent/index.js';
import { CONTENT_ITEM_KEYS } from '../../features/CreateContent/constants.js';
import { Guid } from 'js-guid';
import { SEOMetatagsForm } from '../../shared/ui/SEOMetatagsForm';
import { UploadIcon } from '../../features/UploadIcon/ui/UploadIcon';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField, FormLoading } from '../../shared/ui/FormLayout';

export const CreateVacancyPage = () => {
  const [currencies, setCurrencies] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: '',
    currencyId: 0,
    salaryFrom: 0,
    salaryTo: 0,
    innerContent: {
      items: [],
    },
    expierence: {
      yearsFrom: 0,
      yearsTo: null,
    },
    categoryId: 0,
    mainLanguageId: 1,
    availability: {
      availableInAllCountries: true,
      allowedCountriesIds: [],
      disallowedCountriesIds: [],
    },
    SEOMetatags: {
      Title: null,
      Description: null,
      Keywords: null,
    },
    skills: [],
    imgBackgroundColorHex: '#FFFFFF',
    logoImg: null,
  });
  
  // Состояние для управления навыками
  const [skillInput, setSkillInput] = useState('');

  useEffect(() => {
    const getData = async () => {
      try {
        const [currenciesRes, categoriesRes] = await Promise.all([
          apiRequests.currencies.get(),
          apiRequests.hr.getCategories()
        ]);
        setCurrencies(currenciesRes);
        setCategories(categoriesRes);
        setForm((prev) => ({
          ...prev,
          currencyId: currenciesRes.items[0]?.id || 0,
          categoryId: categoriesRes.items[0]?.id || 0
        }));
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, []);

  const handleAddContent = (value) => {
    setForm((prev) => ({
      ...prev,
      innerContent: {
        items: [...prev.innerContent.items, { guid: value.id, discriminator: value.type }],
      },
    }));
  };

  const handleChangeContent = (value) => {
    setForm((prev) => {
      const newContentItems = prev.innerContent.items.map((i) => {
        if (i.guid === value.id) {
          return {
            ...i,
            [CONTENT_ITEM_KEYS[value.type]]: value.content,
          };
        } else {
          return i;
        }
      });
      return { ...prev, innerContent: { items: newContentItems } };
    });
  };

  const handleDelete = (id) => {
    setForm((prev) => ({
      ...prev,
      innerContent: {
        items: prev.innerContent.items.filter((i) => i.guid !== id),
      },
    }));
  };

  // Добавление навыка
  const addSkill = () => {
    if (skillInput.trim() === '') return;
    
    setForm(prev => ({
      ...prev,
      skills: [...prev.skills, { id: Guid.newGuid().toString(), title: skillInput.trim() }]
    }));
    setSkillInput('');
  };

  // Удаление навыка
  const removeSkill = (skillId) => {
    setForm(prev => ({
      ...prev,
      skills: prev.skills.filter(skill => skill.id !== skillId)
    }));
  };
  
  // Обработка нажатия Enter при вводе навыка
  const handleSkillInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addSkill();
    }
  };
  
  // Обработка загрузки иконки
  const handleLogoUpload = (blob) => {
    setForm(prev => ({ ...prev, logoImg: blob }));
  };

  const handleRequest = async () => {
    try {
      // Проверка обязательных полей
      if (!form.title || !form.categoryId) {
        toast.error('Заполните обязательные поля');
        return;
      }
      
      const body = new FormData();
      const bodyItems = form.innerContent.items.map((i) => {
        switch (i.discriminator) {
          case 'TextContentItem':
            return i;
          case 'ImageSliderContentItem':
            console.log(i);
            const items = i.images.map((z) => {
              const guid = Guid.newGuid().toString();
              body.append(guid, z.imgPath);
              return { imgPath: '', guid, discriminator: 'ImageContentItem' };
            });
            return { ...i, images: items };
          default:
            console.log(i);
            body.append(i.guid, i[CONTENT_ITEM_KEYS[i.discriminator]]);
            return { ...i, [CONTENT_ITEM_KEYS[i.discriminator]]: '' };
        }
      });
      
      // Создаем копию данных для модификации
      const bodyModel = JSON.parse(JSON.stringify(form));
      bodyModel.innerContent.items = bodyItems;
      
      // Корректировка структуры данных согласно API
      
      // Исправляем регистр для соответствия API
      // Преобразуем ключи к верхнему регистру и удаляем исходные поля
      
      if (bodyModel.title) {
        bodyModel.Title = bodyModel.title;
        delete bodyModel.title;
      }
      
      if (bodyModel.imgBackgroundColorHex) {
        bodyModel.ImgBackgroundColorHex = bodyModel.imgBackgroundColorHex;
        delete bodyModel.imgBackgroundColorHex;
      }
      
      if (bodyModel.innerContent) {
        bodyModel.InnerContent = bodyModel.innerContent;
        delete bodyModel.innerContent;
      }
      
      if (bodyModel.seoMetatags) {
        bodyModel.SEOMetatags = bodyModel.seoMetatags;
        delete bodyModel.seoMetatags;
      }
      
      if (bodyModel.currencyId) {
        bodyModel.CurrencyId = Number(bodyModel.currencyId);
        delete bodyModel.currencyId;
      }
      
      if (bodyModel.salaryFrom) {
        bodyModel.SalaryFrom = bodyModel.salaryFrom;
        delete bodyModel.salaryFrom;
      }
      
      if (bodyModel.salaryTo) {
        bodyModel.SalaryTo = bodyModel.salaryTo;
        delete bodyModel.salaryTo;
      }
      
      if (bodyModel.expierence) {
        bodyModel.Expierence = bodyModel.expierence;
        delete bodyModel.expierence;
      }
      
      if (bodyModel.mainLanguageId) {
        bodyModel.MainLanguageId = bodyModel.mainLanguageId;
        delete bodyModel.mainLanguageId;
      }
      
      // Преобразуем categoryId в число и добавляем Category
      if (bodyModel.categoryId) {
        const categoryIdNumber = Number(bodyModel.categoryId);
        
        // Ищем выбранную категорию в списке категорий
        const selectedCategory = categories?.items?.find(cat => cat.id === categoryIdNumber);
        
        // Добавляем объект Category согласно структуре API
        bodyModel.Category = {
          Title: selectedCategory?.title || '',
          Id: categoryIdNumber
        };
        
        // Устанавливаем CategoryId и удаляем старый categoryId
        bodyModel.CategoryId = categoryIdNumber;
        delete bodyModel.categoryId;
      }
      
      // Исправляем структуру Skills - только поле Title без id
      if (bodyModel.skills && Array.isArray(bodyModel.skills)) {
        // Отправляем только значения навыков без локальных id
        bodyModel.Skills = bodyModel.skills.map(skill => ({
          Title: skill.title
        }));
        
        // Удаляем оригинальное поле skills с id, чтобы оно не попало в запрос
        delete bodyModel.skills;
      }
      
      // Проверка и корректировка поля availability
      if (!bodyModel.availability) {
        bodyModel.availability = {
          availableInAllCountries: true,
          allowedCountriesIds: [],
          disallowedCountriesIds: []
        };
      }
      
      // Исправляем регистр полей в Availability согласно структуре API
      bodyModel.Availability = {
        AvailableInAllCountries: bodyModel.availability.availableInAllCountries,
        AllowedCountriesIds: bodyModel.availability.allowedCountriesIds || [],
        DisallowedCountriesIds: bodyModel.availability.disallowedCountriesIds || []
      };
      
      // Удаляем оригинальное поле availability с маленькой буквы
      delete bodyModel.availability;
      
      // Убедимся, что цвет фона начинается с #
      if (bodyModel.ImgBackgroundColorHex && !bodyModel.ImgBackgroundColorHex.startsWith('#')) {
        bodyModel.ImgBackgroundColorHex = `#${bodyModel.ImgBackgroundColorHex}`;
      }
      
      // Приведем SEOMetatags к правильному формату с правильными ключами
      if (bodyModel.SEOMetatags) {
        bodyModel.SEOMetatags = {
          Title: bodyModel.SEOMetatags.title || bodyModel.SEOMetatags.Title || '',
          Description: bodyModel.SEOMetatags.description || bodyModel.SEOMetatags.Description || '',
          Keywords: bodyModel.SEOMetatags.keywords || bodyModel.SEOMetatags.Keywords || ''
        };
      } else {
        bodyModel.SEOMetatags = {
          Title: '',
          Description: '',
          Keywords: ''
        };
      }
      
      // Добавляем сериализованные данные модели в FormData
      body.append('model', JSON.stringify(bodyModel));
      
      // Добавляем логотип вакансии, если он был загружен
      if (form.logoImg) {
        // Создаем новый файл с правильным именем и расширением
        const fileType = form.logoImg.type || 'image/png';
        const fileExt = fileType.split('/')[1] || 'png';
        const fileName = `vacancy_logo_${Date.now()}.${fileExt}`;
        
        // Создаем новый файл с правильным именем
        const fileWithName = new File([form.logoImg], fileName, { type: fileType });
        
        body.append('logoImg', fileWithName);
      }
      
      console.log('Отправляемые данные:', bodyModel);
      
      // Отправляем запрос
      const query = apiRequests.hr.createVacancy(body);
      toast.promise(query, {
        pending: 'Запрос к серверу',
        error: 'Произошла ошибка',
        success: 'Вакансия успешно создана',
      });
    } catch (error) {
      console.error('Ошибка при подготовке данных:', error);
      toast.error('Ошибка при подготовке данных');
    }
  };

  if (loading) return <FormLoading />;

  return (
    <FormLayout
      onSubmit={handleRequest}
      onBack={() => navigate('/hr/vacancies')}
      saving={saving}
      submitText="Создать вакансию"
      savingText="Создание..."
    >
      <FormSection title="Основная информация">
        <Row>
          <Col lg={8}>
            <FormField label="Название" required>
              <Form.Control
                type="text"
                value={form.title}
                onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
                placeholder="Введите название вакансии"
              />
            </FormField>

            <Row>
              <Col md={4}>
                <FormField label="Ставка от">
                  <Form.Control
                    type="number"
                    value={form.salaryFrom}
                    onChange={(e) => setForm((prev) => ({ ...prev, salaryFrom: e.target.value }))}
                  />
                </FormField>
              </Col>
              <Col md={4}>
                <FormField label="Ставка до">
                  <Form.Control
                    type="number"
                    value={form.salaryTo}
                    onChange={(e) => setForm((prev) => ({ ...prev, salaryTo: e.target.value }))}
                  />
                </FormField>
              </Col>
              <Col md={4}>
                <FormField label="Валюта">
                  <Form.Select
                    value={form.currencyId}
                    onChange={(e) => setForm((prev) => ({ ...prev, currencyId: Number(e.target.value) }))}
                  >
                    {currencies?.items?.map((c) => (
                      <option key={c.id} value={c.id}>{c.title}</option>
                    ))}
                  </Form.Select>
                </FormField>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormField label="Категория">
                  <Form.Select
                    value={form.categoryId}
                    onChange={(e) => setForm((prev) => ({ ...prev, categoryId: Number(e.target.value) }))}
                  >
                    {categories?.items?.map((c) => (
                      <option key={c.id} value={c.id}>{c.title}</option>
                    ))}
                  </Form.Select>
                </FormField>
              </Col>
              <Col md={3}>
                <FormField label="Опыт от (лет)">
                  <Form.Control
                    type="number"
                    value={form.expierence.yearsFrom}
                    onChange={(e) => setForm((prev) => ({
                      ...prev,
                      expierence: { ...prev.expierence, yearsFrom: e.target.value }
                    }))}
                  />
                </FormField>
              </Col>
              <Col md={3}>
                <FormField label="Опыт до (лет)">
                  <Form.Control
                    type="number"
                    value={form.expierence.yearsTo || ''}
                    onChange={(e) => setForm((prev) => ({
                      ...prev,
                      expierence: { ...prev.expierence, yearsTo: e.target.value || null }
                    }))}
                  />
                </FormField>
              </Col>
            </Row>
          </Col>

          <Col lg={4}>
            <FormField label="Иконка вакансии">
              <UploadIcon 
                onSelect={handleLogoUpload} 
                initialIcon={form.logoImg ? URL.createObjectURL(form.logoImg) : null} 
                entityType="vacancy"
              />
            </FormField>
            <FormField label="Цвет фона иконки">
              <div className="d-flex align-items-center">
                <input
                  type="color"
                  value={form.imgBackgroundColorHex}
                  onChange={(e) => setForm(prev => ({ ...prev, imgBackgroundColorHex: e.target.value }))}
                  className="me-2"
                  style={{ width: '40px', height: '38px' }}
                />
                <Form.Control
                  type="text"
                  value={form.imgBackgroundColorHex}
                  onChange={(e) => setForm(prev => ({ ...prev, imgBackgroundColorHex: e.target.value }))}
                  placeholder="#FFFFFF"
                />
              </div>
            </FormField>
          </Col>
        </Row>
      </FormSection>

      <FormSection title="Ключевые навыки">
        <div className="d-flex mb-3">
          <Form.Control
            type="text"
            value={skillInput}
            onChange={(e) => setSkillInput(e.target.value)}
            onKeyDown={handleSkillInputKeyDown}
            placeholder="Введите навык и нажмите +"
            className="me-2"
            style={{ maxWidth: '300px' }}
          />
          <Button variant="outline-primary" onClick={addSkill}>+</Button>
        </div>
        <div>
          {form.skills.map(skill => (
            <span key={skill.id} className="badge bg-primary me-2 mb-2 p-2">
              {skill.title}
              <Button variant="link" className="p-0 ms-2 text-white" onClick={() => removeSkill(skill.id)}>✕</Button>
            </span>
          ))}
          {form.skills.length === 0 && <em className="text-muted">Навыки не добавлены</em>}
        </div>
      </FormSection>

      <FormSection title="Контент страницы">
        <CreateContent
          onDelete={handleDelete}
          onChange={handleChangeContent}
          onAdd={handleAddContent}
        />
      </FormSection>

      <FormSection title="Настройки">
        <Row>
          <Col lg={6}>
            <LanguageOptions
              onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))}
            />
          </Col>
        </Row>

        <div className="mt-4">
          <Availability
            onSelect={(val) =>
              setForm((prev) => ({
                ...prev,
                availability: { ...prev.availability, availableInAllCountries: val },
              }))
            }
            onSelectAllowed={(val) =>
              setForm((prev) => ({
                ...prev,
                availability: { ...prev.availability, allowedCountriesIds: val },
              }))
            }
            onSelectDisallowed={(val) =>
              setForm((prev) => ({
                ...prev,
                availability: { ...prev.availability, disallowedCountriesIds: val },
              }))
            }
          />
        </div>
      </FormSection>

      <FormSection title="SEO настройки">
        <SEOMetatagsForm
          seoMetatags={form.SEOMetatags}
          onChange={(metaTags) => setForm((prev) => ({ ...prev, SEOMetatags: metaTags }))}
        />
      </FormSection>
    </FormLayout>
  );
};
